import { render, staticRenderFns } from "./Exwarehouse.vue?vue&type=template&id=185b7e86&scoped=true&"
import script from "./Exwarehouse.vue?vue&type=script&lang=ts&"
export * from "./Exwarehouse.vue?vue&type=script&lang=ts&"
import style0 from "./Exwarehouse.vue?vue&type=style&index=0&id=185b7e86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185b7e86",
  null
  
)

export default component.exports